import React, { useContext } from 'react'
import './Navbar.css'
import { NavLink, Link } from 'react-router-dom'
import { Context } from '../../Context/Context'

import logo from '../Assets/gecko_on_a_wall.png'

const Navbar = () => {
  const { cartItems } = useContext(Context);
  const totalCartItems = Object.values(cartItems || {}).reduce((sum, item) => sum + item, 0);

  return (
    <div className='navbar'>
      <div className='nav-logo'>
        <Link to="/"><img src={logo} alt="" width={110}/></Link>
        <p>Gecko <br />On A Wall</p>
      </div>
      <ul className='nav-links'>
        <li>
          <NavLink  to="/"
            end
            className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
          >
            Home
          </NavLink>
        </li>
        <li>
          <NavLink  to="/stickers"
            end
            className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
          >
            Stickers
          </NavLink>
        </li>
        <li>
          <NavLink  to="/prints"
            end
            className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
          >
            Prints
          </NavLink>
        </li>
        <li>
          <NavLink  to="/contact"
            end
            className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
          >
            Contact
          </NavLink>
        </li>
        <li style={{ position: 'relative' }}>
          <NavLink  to="/cart"
            end
            className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
          >
            Cart
          </NavLink>
          <div className='nav-cart-count'><p>{totalCartItems}</p></div>
        </li>
      </ul>
      
    </div>
  )
}

export default Navbar
